export default __webpack_public_path__ + "static/media/alert_round.1d399929.png";